const HeaderIcon = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
      <rect x="3" y="6" width="18" height="1.5" rx="1" fill="white" />
      <rect x="3" y="11" width="18" height="1.5" rx="1" fill="white" />
      <rect x="3" y="16" width="12" height="1.5" rx="1" fill="white" />
    </svg>
  );
  
  export default HeaderIcon;